import { render, staticRenderFns } from "./bill_send_records.vue?vue&type=template&id=ae01b242"
import script from "./bill_send_records.vue?vue&type=script&lang=js"
export * from "./bill_send_records.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports